// TODO: Upgrade to the latest Redux.
//
// TODO: Update Redux usage according to the latest documentation and use Redux
// Toolkit with createAction/match instead of the current boilerplate code.
// https://redux.js.org/redux-toolkit/overview
//
// TODO: Implement best practices: https://redux.js.org/style-guide/

import { LanguageInfo, ScaniaReadMoreTextNode } from '../api/generated'
import { EtelMarketAndLanguage, FactoryModelsStartupData } from '../api/startup'
import { ScaniaAdobeTrackingPageName } from '../utils/adobeAnalytics'

export interface LoginStatus {
  isloggedin: boolean
  userMail: string
}

export interface MarketLanguageState extends EtelMarketAndLanguage {
  isoLanguageCode: string
  isoMarketCode: string
  isoLocalization: string
  marketFullname: string
  optionalLanguages: LanguageInfo[]
}

export interface FactoryModelsState {
  factoryModels: FactoryModelsStartupData | null
  hasBevModels: boolean
}

export interface ReadMoreData {
  label: string
  images: string[]
  text: ScaniaReadMoreTextNode[] | undefined | null
}

export enum SmartDashCampaignMode {
  None,
  FancyAnimatedLinesAndCurve,
}

// Series/Frame combinations that are unavailable for the current configuration
// and should be subtracted from the complete list of series/frame combinations.
// Called Ignored Frames in the web API.
export interface ImageSeriesFrame {
  seriesId: string // eg. "EXTERIOR", "INTERIOR", "360"
  frameId: number
}

export enum ExtendedCheckStatus {
  None,
  WaitingForResult,
  Success,
  Failure,
}

export interface PageViewTrackingEventPayload {
  pageName: ScaniaAdobeTrackingPageName
  marketLanguage: MarketLanguageState
}

export interface SessionError {
  errorLevel: number
  friendlyErrorMessage: string | null
  errorMessage: string | null
}

export interface ColorMenuInfo {
  colorIds: string[] | null
  isColorMenu: boolean
}

export enum SidePanelContent {
  'save',
  'share',
  'activeChanges',
  'readMore',
  'info',
  'garage',
  'login',
}

export enum GuidedViewPageType {
  'overview',
  'guidedView',
  'allView',
  'rfq',
  'summary',
}

export enum CocOpenedFromType {
  'guidedView',
  'allView',
  'xml',
}
